import { request, success, failure, ASSET_REQUEST, ALLOCATED_ASSETS_REQUEST } from "./utilities";
import {
    getAssets,
    addNewAsset,
    getAssetTypes,
    addNewAssetTypes,
    removeAssetType,
    getAllocatedAssets,
    removeAsset,
    addNewAllocatedAsset,
    removeAllocatedAsset
} from '../api';

export function getAssetsList() {
    return (dispatch) => {
        dispatch(request(ASSET_REQUEST.GET_ASSETS_REQUEST));
        var response = [
            {
                id: 0,
                assetName: "Laptop",
                assetType: "Mechanical",
                assetTypeId: 0,
                amount: 25000,
                paidBy: "Usama Ikram",
                purchasingDate: "09/11/2020",
                status: "Active",
                statusId: 7
            },
            {
                id: 1,
                assetName: "LCD",
                assetType: "Mechanical",
                assetTypeId: 0,
                amount: 25000,
                paidBy: "Usama Ikram",
                purchasingDate: "09/11/2020",
                status: "De-active",
                statusId: 8
            },
            {
                id: 2,
                assetName: "Mobile",
                assetType: "Mechanical",
                assetTypeId: 0,
                amount: 25000,
                paidBy: "Usama Ikram",
                purchasingDate: "09/11/2020",
                status: "Sold Out",
                statusId: 9
            },
            {
                id: 3,
                assetName: "Laptop",
                assetType: "Mechanical", assetTypeId: 0,
                amount: 25000,
                paidBy: "Usama Ikram",
                purchasingDate: "09/11/2020",
                status: "Active",
                statusId: 7
            },
            {
                id: 4,
                assetName: "Laptop",
                assetType: "Mechanical", assetTypeId: 0,
                amount: 25000,
                paidBy: "Usama Ikram",
                purchasingDate: "09/11/2020",
                status: "De-active",
                statusId: 8
            },
            {
                id: 5,
                assetName: "Laptop",
                assetType: "Mechanical", assetTypeId: 0,
                amount: 25000,
                paidBy: "Usama Ikram",
                purchasingDate: "09/11/2020",
                status: "Sold Out",
                statusId: 9
            },
            {
                id: 6,
                assetName: "Laptop",
                assetType: "Mechanical", assetTypeId: 0,
                amount: 25000,
                paidBy: "Usama Ikram",
                purchasingDate: "09/11/2020",
                status: "Active",
                statusId: 7
            },
            {
                id: 7,
                assetName: "Laptop",
                assetType: "Mechanical", assetTypeId: 0,
                amount: 25000,
                paidBy: "Usama Ikram",
                purchasingDate: "09/11/2020",
                status: "De-active",
                statusId: 8
            },
            {
                id: 8,
                assetName: "Laptop",
                assetType: "Mechanical", assetTypeId: 0,
                amount: 25000,
                paidBy: "Usama Ikram",
                purchasingDate: "09/11/2020",
                status: "Sold Out",
                statusId: 9
            },
            {
                id: 9,
                assetName: "Laptop",
                assetType: "Mechanical", assetTypeId: 0,
                amount: 25000,
                paidBy: "Usama Ikram",
                purchasingDate: "09/11/2020",
                status: "Active",
                statusId: 7
            },
            {
                id: 10,
                assetName: "Laptop",
                assetType: "Mechanical", assetTypeId: 0,
                amount: 25000,
                paidBy: "Usama Ikram",
                purchasingDate: "09/11/2020",
                status: "De-active",
                statusId: 8
            },
            {
                id: 11,
                assetName: "Laptop",
                assetType: "Mechanical", assetTypeId: 0,
                amount: 25000,
                paidBy: "Usama Ikram",
                purchasingDate: "09/11/2020",
                status: "Sold Out",
                statusId: 9
            },
            {
                id: 12,
                assetName: "Laptop",
                assetType: "Mechanical", assetTypeId: 0,
                amount: 25000,
                paidBy: "Usama Ikram",
                purchasingDate: "09/11/2020",
                status: "Active",
                statusId: 7
            },
            {
                id: 13,
                assetName: "Laptop",
                assetType: "Mechanical", assetTypeId: 0,
                amount: 25000,
                paidBy: "Usama Ikram",
                purchasingDate: "09/11/2020",
                status: "De-active",
                statusId: 8
            },
            {
                id: 14,
                assetName: "Laptop",
                assetType: "Mechanical", assetTypeId: 0,
                amount: 25000,
                paidBy: "Usama Ikram",
                purchasingDate: "09/11/2020",
                status: "Sold Out",
                statusId: 9
            },
            {
                id: 15,
                assetName: "Laptop",
                assetType: "Mechanical", assetTypeId: 0,
                amount: 25000,
                paidBy: "Usama Ikram",
                purchasingDate: "09/11/2020",
                status: "Active",
                statusId: 7
            },
            {
                id: 16,
                assetName: "Laptop",
                assetType: "Mechanical", assetTypeId: 0,
                amount: 25000,
                paidBy: "Usama Ikram",
                purchasingDate: "09/11/2020",
                status: "De-active",
                statusId: 8
            },
            {
                id: 17,
                assetName: "Laptop",
                assetType: "Mechanical", assetTypeId: 0,
                amount: 25000,
                paidBy: "Usama Ikram",
                purchasingDate: "09/11/2020",
                status: "Sold Out",
                statusId: 9
            },
            {
                id: 18,
                assetName: "Laptop",
                assetType: "Mechanical", assetTypeId: 0,
                amount: 25000,
                paidBy: "Usama Ikram",
                purchasingDate: "09/11/2020",
                status: "Active",
                statusId: 7
            },
            {
                id: 19,
                assetName: "Laptop",
                assetType: "Mechanical", assetTypeId: 0,
                amount: 25000,
                paidBy: "Usama Ikram",
                purchasingDate: "09/11/2020",
                status: "De-active",
                statusId: 8
            },
            {
                id: 20,
                assetName: "Laptop",
                assetType: "Mechanical", assetTypeId: 0,
                amount: 25000,
                paidBy: "Usama Ikram",
                purchasingDate: "09/11/2020",
                status: "Sold Out",
                statusId: 9
            },
            {
                id: 21,
                assetName: "Laptop",
                assetType: "Mechanical", assetTypeId: 0,
                amount: 25000,
                paidBy: "Usama Ikram",
                purchasingDate: "09/11/2020",
                status: "Active",
                statusId: 7
            },
            {
                id: 22,
                assetName: "Laptop",
                assetType: "Mechanical", assetTypeId: 0,
                amount: 25000,
                paidBy: "Usama Ikram",
                purchasingDate: "09/11/2020",
                status: "De-active",
                statusId: 8
            },
            {
                id: 23,
                assetName: "Laptop",
                assetType: "Mechanical", assetTypeId: 0,
                amount: 25000,
                paidBy: "Usama Ikram",
                purchasingDate: "09/11/2020",
                status: "Sold Out",
                statusId: 9
            }
        ]
        dispatch(success(ASSET_REQUEST.GET_ASSETS_SUCCESS, response))
        // getAssets().then(
        //     response => {
        //         if (response.data.status === 1) {
        //             dispatch(success(ASSET_REQUEST.GET_ASSETS_SUCCESS, response.data.data))
        //         }
        //         else {
        //             dispatch(failure(ASSET_REQUEST.GET_ASSETS_FAILURE, response.data.message))
        //         }
        //     },
        //     error => {
        //         dispatch(failure(ASSET_REQUEST.GET_ASSETS_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        //     }
        // )
    }
}

export function deleteAssetFromList(assetId) {
    return (dispatch) => {
        dispatch(request(ASSET_REQUEST.DELETE_ASSETS_REQUEST))
        dispatch(success(ASSET_REQUEST.DELETE_ASSETS_SUCCESS, assetId));
        // removeAsset(assetId).then(
        //     response => {
        //         if (response.data.status === 1) {
        //             dispatch(success(ASSET_REQUEST.DELETE_ASSETS_SUCCESS, assetId));
        //         }
        //         else {
        //             dispatch(failure(ASSET_REQUEST.DELETE_ASSETS_FAILURE, response.data.message))
        //         }
        //     },
        //     error => {
        //         dispatch(failure(ASSET_REQUEST.DELETE_ASSETS_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        //     }
        // )
    }
}

export function editAssetFromList(assetData, close) {
    return (dispatch) => {
        dispatch(request(ASSET_REQUEST.EDIT_ASSETS_REQUEST));
        dispatch(success(ASSET_REQUEST.EDIT_ASSETS_SUCCESS, assetData));
        if (close) {
            close()
        }
        //     addNewAsset(assetData).then(
        //         response => {
        //             if (response.data.status === 1) {
        //                 dispatch(success(ASSET_REQUEST.EDIT_ASSETS_SUCCESS, response.data.data));
        //                 if (close) {
        //                     close()
        //                 }
        //             }
        //             else {
        //                 dispatch(failure(ASSET_REQUEST.EDIT_ASSETS_FAILURE, response.data.message))
        //             }
        //         },
        //         error => {
        //             dispatch(failure(ASSET_REQUEST.EDIT_ASSETS_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        //         }
        //     )
    }
}

export function addNewAssetToList(assetData, close) {
    return (dispatch) => {
        dispatch(request(ASSET_REQUEST.ADD_ASSETS_REQUEST));
        dispatch(success(ASSET_REQUEST.ADD_ASSETS_SUCCESS, assetData));
        if (close) {
            close()
        }
        // addNewAsset(assetData).then(
        //     response => {
        //         if (response.data.status === 1) {
        //             dispatch(success(ASSET_REQUEST.ADD_ASSETS_SUCCESS, response.data.data));
        //             if (close) {
        //                 close()
        //             }
        //         }
        //         else {
        //             dispatch(failure(ASSET_REQUEST.ADD_ASSETS_FAILURE, response.data.message))
        //         }
        //     },
        //     error => {
        //         dispatch(failure(ASSET_REQUEST.ADD_ASSETS_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        //     }
        // )
    }
}
export function getAssetTypesList() {
    return (dispatch) => {
        dispatch(request(ASSET_REQUEST.GET_ASSETS_TYPE_REQUEST));
        var response = [
            {
                id: 0,
                type: "Mechanical"
            },
            {
                id: 1,
                type: "Technical"
            }
        ]
        dispatch(success(ASSET_REQUEST.GET_ASSETS_TYPE_SUCCESS, response));
        // getAssetTypes().then(
        //     response => {
        //         if (response.data.status === 1) {
        //             dispatch(success(ASSET_REQUEST.GET_ASSETS_TYPE_SUCCESS, response.data.data));
        //         }
        //         else {
        //             dispatch(failure(ASSET_REQUEST.GET_ASSETS_TYPE_FAILURE, response.data.message))
        //         }
        //     },
        //     error => {
        //         dispatch(failure(ASSET_REQUEST.GET_ASSETS_TYPE_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        //     }
        // )
    }
}

export function addNewAssetType(assetTypeData, close) {
    return (dispatch) => {
        dispatch(request(ASSET_REQUEST.ADD_ASSETS_TYPE_REQUEST));
        dispatch(success(ASSET_REQUEST.ADD_ASSETS_TYPE_SUCCESS, assetTypeData))
        if (close) {
            close()
        }
        // addNewAssetType(assetTypeData).then(
        //     response => {
        //         if (response.data.status === 1) {
        //             dispatch(success(ASSET_REQUEST.ADD_ASSETS_TYPE_SUCCESS, response.data.data))
        //             if (close) {
        //                 close()
        //             }
        //         }
        //         else {
        //             dispatch(failure(ASSET_REQUEST.ADD_ASSETS_TYPE_FAILURE, response.data.message))
        //         }
        //     },
        //     error => {
        //         dispatch(failure(ASSET_REQUEST.ADD_ASSETS_TYPE_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        //     }
        // )
    }
}

export function deleteAssetType(assetTypeId) {
    return (dispatch) => {
        dispatch(request(ASSET_REQUEST.DELETE_ASSETS_TYPE_REQUEST));
        dispatch(success(ASSET_REQUEST.DELETE_ASSETS_TYPE_SUCCESS, assetTypeId));
        // removeAssetType(assetTypeId).then(
        //     response => {
        //         if (response.data.status === 1) {
        //             dispatch(success(ASSET_REQUEST.DELETE_ASSETS_TYPE_SUCCESS, assetTypeId));
        //         }
        //         else {
        //             dispatch(failure(ASSET_REQUEST.DELETE_ASSETS_TYPE_FAILURE, response.data.message))
        //         }
        //     },
        //     error => {
        //         dispatch(failure(ASSET_REQUEST.DELETE_ASSETS_TYPE_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        //     }
        // )
    }
}

export function editAssetType(assetTypeData) {
    return (dispatch) => {
        dispatch(request(ASSET_REQUEST.EDIT_ASSETS_TYPE_REQUEST));
        dispatch(success(ASSET_REQUEST.EDIT_ASSETS_TYPE_SUCCESS, assetTypeData))
        // addNewAssetType(assetTypeData).then(
        //     response => {
        //         if (response.data.status === 1) {
        //             dispatch(success(ASSET_REQUEST.EDIT_ASSETS_TYPE_SUCCESS, response.data.data))
        //         }
        //         else {
        //             dispatch(failure(ASSET_REQUEST.EDIT_ASSETS_TYPE_FAILURE, response.data.message))
        //         }
        //     },
        //     error => {
        //         dispatch(failure(ASSET_REQUEST.EDIT_ASSETS_TYPE_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        //     }
        // )
    }
}

export function allocatedAssetsList() {
    return (dispatch) => {
        dispatch(request(ALLOCATED_ASSETS_REQUEST.GET_ALLOCATED_ASSETS_REQUEST))
        var response = [
            {
                id: 0,
                employeeName: "Usama",
                asset: "Laptop",
                allocationDate: "09/11/2020",
                releaseDate: "09/11/2020",
                status: "In Use",
                statusId: 10
            },
            {
                id: 1,
                employeeName: "Faizan",
                asset: "Mobile",
                allocationDate: "09/11/2020",
                releaseDate: "-",
                status: "Released",
                statusId: 11
            }
        ]
        dispatch(success(ALLOCATED_ASSETS_REQUEST.GET_ALLOCATED_ASSETS_SUCCESS, response))
        // getAllocatedAssets().then(
        //     response => {
        //         if (response.data.status === 1) {
        //             dispatch(success(ALLOCATED_ASSETS_REQUEST.GET_ALLOCATED_ASSETS_SUCCESS, response.data.data))
        //         }
        //         else {
        //             dispatch(failure(ALLOCATED_ASSETS_REQUEST.GET_ALLOCATED_ASSETS_FAILURE, response.data.message))
        //         }
        //     },
        //     error => {
        //         dispatch(failure(ALLOCATED_ASSETS_REQUEST.GET_ALLOCATED_ASSETS_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        //     }
        // )
    }
}
export function addAllocatedAsset(allocatedAssetData, close) {
    return (dispatch) => {
        dispatch(request(ALLOCATED_ASSETS_REQUEST.ADD_ALLOCATED_ASSETS_REQUEST));
        dispatch(success(ALLOCATED_ASSETS_REQUEST.ADD_ALLOCATED_ASSETS_SUCCESS, allocatedAssetData));
        if (close) {
            close();
        }
        // addNewAllocatedAsset(allocatedAssetData).then(
        //     response => {
        //         if (response.data.status === 1) {
        //             dispatch(success(ALLOCATED_ASSETS_REQUEST.ADD_ALLOCATED_ASSETS_SUCCESS, response.data.data));
        //             if (close) {
        //                 close();
        //             }
        //         }
        //         else {
        //             dispatch(failure(ALLOCATED_ASSETS_REQUEST.ADD_ALLOCATED_ASSETS_FAILURE, response.data.message));
        //         }
        //     },
        //     error => {
        //         dispatch(failure(ALLOCATED_ASSETS_REQUEST.ADD_ALLOCATED_ASSETS_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)));
        //     }
        // )
    }
}

export function deleteAllocatedAsset(allocatedAssetId) {
    return (dispatch) => {
        dispatch(request(ALLOCATED_ASSETS_REQUEST.REMOVE_ALLOCATED_ASSETS_REQUEST));
        dispatch(success(ALLOCATED_ASSETS_REQUEST.REMOVE_ALLOCATED_ASSETS_SUCCESS, allocatedAssetId))
        // removeAllocatedAsset(allocatedAssetId).then(
        //     response => {
        //         if (response.data.status === 1) {
        //             dispatch(success(ALLOCATED_ASSETS_REQUEST.REMOVE_ALLOCATED_ASSETS_SUCCESS, allocatedAssetId))
        //         }
        //         else {
        //             dispatch(failure(ALLOCATED_ASSETS_REQUEST.REMOVE_ALLOCATED_ASSETS_FAILURE, response.data.message))
        //         }
        //     },
        //     error => {
        //         dispatch(failure(ALLOCATED_ASSETS_REQUEST.REMOVE_ALLOCATED_ASSETS_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        //     }
        // )
    }
}
export function editAllocatedAsset(allocatedAssetData, close) {
    return (dispatch) => {
        dispatch(request(ALLOCATED_ASSETS_REQUEST.EDIT_ALLOCATED_ASSETS_REQUEST));
        dispatch(success(ALLOCATED_ASSETS_REQUEST.EDIT_ALLOCATED_ASSETS_SUCCESS, allocatedAssetData));
        if (close) {
            close();
        }
        // addNewAllocatedAsset(allocatedAssetData).then(
        //     response => {
        //         if (response.data.status === 1) {
        //             dispatch(success(ALLOCATED_ASSETS_REQUEST.EDIT_ALLOCATED_ASSETS_SUCCESS, response.data.data));
        //             if (close) {
        //                 close();
        //             }
        //         }
        //         else {
        //             dispatch(failure(ALLOCATED_ASSETS_REQUEST.EDIT_ALLOCATED_ASSETS_FAILURE, response.data.message));
        //         }
        //     },
        //     error => {
        //         dispatch(failure(ALLOCATED_ASSETS_REQUEST.EDIT_ALLOCATED_ASSETS_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)));
        //     }
        // )
    }
}